import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'narwhalia-exchange',
  templateUrl: './exchange.component.html',
  styleUrls: ['./exchange.component.scss']
})
export class ExchangeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
